import type {
  InvoiceLineItem,
  PoGstMode,
  PurchaseOrder,
  PurchaseOrderItem,
} from '../types';
import { computePoTotals } from './nzGst';

export function newInvoiceLine(overrides?: Partial<InvoiceLineItem>): InvoiceLineItem {
  return {
    lineId: `line-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    description: '',
    quantity: 1,
    unit: 'units',
    unitPrice: 0,
    ...overrides,
  };
}

export function poItemsToInvoiceLines(items: PurchaseOrderItem[]): InvoiceLineItem[] {
  return items.map((line) =>
    newInvoiceLine({
      lineId: line.lineId,
      description: line.productName,
      quantity: line.quantity,
      unit: line.unit ?? 'units',
      unitPrice: line.costPerUnit,
    }),
  );
}

export function invoiceLineTotal(line: InvoiceLineItem): number {
  return (line.quantity || 0) * (line.unitPrice || 0);
}

export function invoiceItemsTotal(items: InvoiceLineItem[], gstMode?: PoGstMode): number {
  if (gstMode) {
    const mapped = items.map((line) => ({
      lineId: line.lineId,
      productName: line.description,
      quantity: line.quantity,
      costPerUnit: line.unitPrice,
      unit: line.unit as PurchaseOrderItem['unit'],
    }));
    return computePoTotals(mapped, gstMode).totalIncGst;
  }
  return items.reduce((sum, line) => sum + invoiceLineTotal(line), 0);
}

export function generateSupplierInvoiceId(): string {
  return `SINV-${Date.now()}`;
}

export function generateClientInvoiceId(): string {
  return `CINV-${Date.now()}`;
}

export function suggestClientInvoiceNumber(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  return `INV-${y}${m}-${String(now.getTime() % 10000).padStart(4, '0')}`;
}
